import React, { useState } from 'react'
import styles from './LeadQualityScreen.module.css'
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import LeadQualityBarChart from './LeadQualityBarChart';
import NotAvaliableDataImage from '../../Assets/Images/not-avaliable.svg'
import CenteredPopUp from '../../Components/CenteredPopUp/CenteredPopUp';
import LeadRecommendationPopupContent from './LeadRecommendationPopupContent';
import { connect, useDispatch } from "react-redux";

interface LeadPerformanceCardComponentProps {
    data: any,
    lqcScoreDescriptions: any
}

const LeadPerformanceCardComponent: React.FC<LeadPerformanceCardComponentProps> = ({ data, lqcScoreDescriptions }) => {
    const [openReadMore, setOpenReadMore] = useState<boolean>(false);
    const readMoreHandler  = () => {
        document.body.classList.add("no-overflow");
        setOpenReadMore(true)
    }
    let leadCallingScoreType = lqcScoreDescriptions?.overallLeadQualification ? lqcScoreDescriptions.overallLeadQualification.toLowerCase() : "";
    return (
        <div className={styles.LqscsCard}>
            <div className={styles.LqscsCardHeader}>
                <div className={styles.LqscsCardTitle}>{data.cardTitle}</div>
                <div className={styles.LqscsCardSubTitle}>{data.cardSubtitle}</div>
            </div>
            <div className={styles.LqscsCardBody}>
                {
                    (data.report_display === "Y") ?
                        <div className={styles.LqscsCardBodyLeft}>
                            <div>
                            <LeadQualityBarChart
                                chartDatas={[data.totalQalificationPercent, data.inOneHourQalificationPercent, data.afterOneHourQalificationPercent]}
                                backgrounds={["#303030", "#80cbc0", "#febd38"]}
                                labels={['Overall', 'For leads called within 1 hr', 'For leads called post 1 hr']}
                                canvasId="performanceChart"
                            />
                            </div>
                            <div className={styles.LqscsCallingDatabox}>
                                <div className={styles.LqscsCallData}>
                                    <div className={styles.LqscsCallDataLabelBar}>Overall</div>
                                </div>
                                <div className={styles.LqscsCallData}>
                                    <div className={styles.LqscsCallDataLabelBar}>For leads called within 1 hr</div>
                                </div>
                                <div className={styles.LqscsCallData}>
                                    <div className={styles.LqscsCallDataLabelBar}>For leads called post 1 hr</div>
                                </div>
                            </div>
                        </div>
                        :
                        <div className={`${styles.LqscsCardBodyLeft} ${styles['fallback']}`}>
                            <img src={NotAvaliableDataImage} alt='no-image' width={"100%"} />
                        </div>
                }

                {
                    (data.report_display === "Y") ?
                        <div className={styles.LqscsCardBodyRight}>
                            <div className={`${styles.LqscsPercentageInfo} ${styles['qualiRate']}`}>
                                <div className={styles.LqscsPercentageData}>
                                    <div className={`${styles.LqscsPercentageDataVal} ${styles['qualiRate']}`}>{data.totalQalificationPercent}<span className={styles.LqscsPercentageDataLabel}>Qualification Rate</span></div>
                                    <div className={`${styles.LqscsPercentageDataLabel} ${styles['qualiRate']}`}>For your total received leads</div>
                                </div>
                                <div className={styles.LqscsScroreType}>
                                    <div className={`${styles.LqscsTitleTag} ${styles[leadCallingScoreType]}`}>{leadCallingScoreType}</div>
                                    {(leadCallingScoreType !== "moderate") && <div className={`${styles.LqscsScroreTypeTxt} ${styles[leadCallingScoreType]}`}>Among {(leadCallingScoreType == "good") && "Top"} {(leadCallingScoreType == "poor") && "Bottom"} 20%</div>}
                                </div>
                            </div>
                            {/* <div className={styles.LqscsHighlight}>Top agents in your city call 99% of their leads</div> */}
                            <div className={styles.LqspQualifications}>
                                <div className={styles.LqspQualificationCard}>
                                    <div className={styles.LqspQualificationRate}>
                                        <div className={styles.LqspQualificationRateData}><span className={styles.TextBlue}>{data.inOneHourQalificationPercent}</span> <span className={styles.TextHightlight}>Qualification Rate</span></div>
                                        <div className={styles.LqspQualificationRateLabel}>For leads called <span className={styles.TextHightlight}>within 1 hour</span></div>
                                    </div>
                                </div>
                                <div className={styles.LqspQualificationCard}>
                                    <div className={styles.LqspQualificationRate}>
                                        <div className={styles.LqspQualificationRateData}><span className={styles.TextYellow}>{data.afterOneHourQalificationPercent}</span> <span className={styles.TextHightlight}>Qualification Rate</span></div>
                                        <span className={styles.LqspQualificationRateLabel}>For leads called <span className={styles.TextHightlight}>after 1 hour</span></span>
                                    </div>
                                </div>
                            </div>
                            {
                                (leadCallingScoreType !== "poor") ? <div className={`${styles.LqscsBanner} ${styles[leadCallingScoreType]}`}>
                                    <span className={`${styles.LqscsBannerIcon} ${styles[leadCallingScoreType]}`}>
                                        {(leadCallingScoreType == "good") && <ThumbUpIcon className={styles.ThumbUpIcon} />}
                                        {(leadCallingScoreType == "moderate") && <InfoOutlinedIcon className={styles.infoIcon} />}
                                    </span>
                                    {
                                        // data.leadCallingScoreMessage
                                        lqcScoreDescriptions.overallLeadQualificationValueMessage 
                                        // (leadCallingScoreType == "good") ? "Great! Keep calling all your leads to maximize conversions."
                                        //     :
                                        //     (leadCallingScoreType == "moderate") ? "Reduce response time to get even better conversion"
                                        //         :
                                        //         ""
                                    }
                                    <span className={styles.ReadMoreCta} onClick={readMoreHandler}>Read More</span>
                                </div>
                                    :
                                    <div className={styles.LqspQualificationImps}>
                                        <div className={styles.LqspQualificationImpTitle}>To improve your lead qualification</div>
                                        <div className={styles.LqspQualificationImp}>
                                            <div className={`${styles.LqspQualificationImpoints}`}>
                                                <span className={`${styles.LqscsBannerIcon} ${styles.moderate}`}><InfoOutlinedIcon className={styles.infoIcon} /></span> You need to Reduce response time for the leads.
                                            </div>
                                            <div className={`${styles.LqspQualificationImpoints}`}>
                                                <span className={`${styles.LqscsBannerIcon} ${styles.good}`}><ThumbUpIcon className={styles.ThumbUpIcon} /></span> Magicbricks is reviewing data to identify and recommend fixes.
                                            </div>
                                        </div>
                                    </div>
                            }
                        </div>
                        :
                        <div className={styles.LqscsCardBodyRight}>
                            <div className={styles.LqscsCardBodyRightFbTitle}>{data.thresholdMessage}</div>
                            <div className={styles.LqscsCardBodyRightFbTxt}>{data.thresholdDesc}</div>
                            <div className={`${styles.LqscsBanner} ${styles['moderate']}`}>
                                <span className={`${styles.LqscsBannerIcon} ${styles['moderate']}`}>
                                    <InfoOutlinedIcon className={styles.infoIcon} />
                                </span>
                                Boost your Lead calling score by making more calls, reducing response time, and doing more follow-up calls.
                            </div>
                        </div>
                }
                {
                    openReadMore && <CenteredPopUp
                        setModal={setOpenReadMore}
                        children={
                            <LeadRecommendationPopupContent
                                title={"Lead Qualification"}
                                subtext={"This metric measures the percentage of leads that have expressed interest in your property, reflecting both your calling performance and the quality of the leads you receive."}
                                recommendation={"By refining your approach, you can improve your qualification rate, while Magicbricks uses this data to optimize the system for better results."}
                                scoreType={leadCallingScoreType}
                            />
                        }
                        modiferClass={styles.LcqModal}
                        closeIcon={true}
                        closeClassMofifier={styles.LcqModalClose}
                    />
                }

            </div>
        </div>
    )
}

const mapStateToProps = (state: any) => {
    return {
        lqcScoreDescriptions: state.lqcReportData.lqcScoreDescriptions
    };
};

export default connect(mapStateToProps)(LeadPerformanceCardComponent);